/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs'

import { usePaginatedEvents } from './usePaginatedEvents'
import { Event as EventApi, FormEvent as FormEventApi } from '../API'
import {
  listEventsForDownload,
  listFormEventsForDownload,
} from '../api/queries'
import { DEFAULT_ENTRIES_PER_PAGE } from '../constants/api'
import { fetchQuery } from '../utils/ApiUtils'

type Event = Omit<Exclude<EventApi, null>, '__typename'>
type FormEvent = Omit<Exclude<FormEventApi, null>, '__typename'>

export const getEventForDownload = async (eventId: string) => {
  try {
    const { items } = (await fetchQuery('listEvents', listEventsForDownload, {
      limit: DEFAULT_ENTRIES_PER_PAGE,
      filter: { id: { eq: eventId } },
    })) as unknown as { items: Event[]; nextToken: any }
    return items.length > 0 ? items[0] : null
  } catch (e) {
    console.log(e)
  }
  return null
}

const queryInfo = [
  {
    options: { filter: { endDateTime: { gt: dayjs().tz('Asia/Manila') } } },
    name: 'listEvents',
    query: listEventsForDownload,
    isFP: false,
  },
  {
    options: {
      filter: {
        registrationCutOff: { gt: dayjs().tz('Asia/Manila').subtract(6, 'M') },
      },
    },
    name: 'listFormEvents',
    query: listFormEventsForDownload,
    isFP: true,
  },
]

export const useEventsForDownload = () => {
  const {
    items: events,
    apiLoading,
    apiError,
  } = usePaginatedEvents<Event | FormEvent>(queryInfo)
  return { events, apiLoading, apiError }
}
